import React from 'react';
import withAppLayout from '../../hoc/withAppLayout';

import { SubscriptionContainer } from '../../containers';

const SubscriptionLayout = () => <SubscriptionContainer />;

export const Subscription = withAppLayout(SubscriptionLayout);
